import type { IAccountDoc, IAccountDocAuditEntry, IAccountDocContent } from '@logz-pkg/enums';
import { httpService } from '../../core/http/request.provider';

const BASE = '/orioniq-be/account-docs';

class AccountDocsApiService {
  private urls = {
    docs: BASE,
    doc: (name: string): string => `${BASE}/${encodeURIComponent(name)}`,
    audit: (name: string): string => `${BASE}/${encodeURIComponent(name)}/audit`,
  };

  list = async (): Promise<IAccountDoc[]> => {
    const { data } = await httpService.get<IAccountDoc[]>(this.urls.docs);

    return data;
  };

  getContent = async (name: string): Promise<IAccountDocContent> => {
    const { data } = await httpService.get<IAccountDocContent>(this.urls.doc(name));

    return data;
  };

  upsert = async ({ name, content }: { name: string; content: string }): Promise<unknown> => {
    const { data } = await httpService.put(this.urls.doc(name), { content });

    return data;
  };

  delete = async (name: string): Promise<unknown> => {
    const { data } = await httpService.delete(this.urls.doc(name));

    return data;
  };

  getAudit = async (name: string): Promise<IAccountDocAuditEntry[]> => {
    const { data } = await httpService.get<IAccountDocAuditEntry[]>(this.urls.audit(name));

    return data;
  };
}

export const accountDocsApiService = new AccountDocsApiService();
